// Browser page-translation — Chrome's "Translate this page", Google Translate, and
// translator extensions — rewrites the page's text nodes in place: it replaces each text
// node with its own <font> wrapper, which detaches the original text nodes that React is
// still holding in its fiber tree. When React later unmounts such a subtree it calls
// parentNode.removeChild(textNode) on a node the translator already moved, and the browser
// throws
//   NotFoundError: Failed to execute 'removeChild' on 'Node': The node to be removed is
//   not a child of this node.
// which unwinds the whole React root and blanks the page for that visitor. This was a real
// production crash on the public /dielines pages (translated visitors only, so it never
// reproduced in-house).
//
// We make the two DOM methods React uses while committing an unmount tolerant of a node the
// translator has already detached: if the node is no longer a child of `this`, do nothing
// and return it, instead of throwing. Only the parent-mismatch case is relaxed — every
// other removeChild / insertBefore behaves exactly as before. This is the remedy the React
// team recommends for this class of crash (React issue #11538).
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
